import script from "./ApprovalInboxView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalInboxView.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalInboxView.vue?vue&type=style&index=0&id=28c002bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c002bc"]])

export default __exports__